export const orderSelectionListOptions = [
    {
        key: '1',
        name: '1'
    },
    {
        key: '2',
        name: '2'
    },
    {
        key: '3',
        name: '3'
    },
    {
        key: '4',
        name: '4'
    },
    {
        key: '5',
        name: '5'
    },
    {
        key: '6',
        name: '6'
    },
    {
        key: '7',
        name: '7'
    },
    {
        key: '8',
        name: '8'
    },
    {
        key: '9',
        name: '9'
    },
    {
        key: '10',
        name: '10'
    },
];
